/*
 * Copyright 2023 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import { DialogActions } from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { DrawerFooterV1Props } from "./drawer-footer-v1.interfaces";

export const DrawerFooterV1: FunctionComponent<DrawerFooterV1Props> = ({
    children,
}) => {
    // Render UI
    return <DialogActions>{children}</DialogActions>;
};
